import React, { Component} from 'react';
import { connect }        from 'react-redux';
import { setFilter }      from './../../../actions/FilterAction';
import PlaceInfo          from './../PlaceInfo';
import { browserHistory } from 'react-router';

class PlaceInfoContainer extends Component
{
    render = () =>
    {
        return (
            <PlaceInfo
                goToFilter={ this.props.goToFilter }
                place={ this.props.place }
                theme={ this.props.theme }
            />
        );
    }
}

const mapStateToProps = (state) =>
{
    return {
        place: state.place.item,
        theme: state.assets.items.theme,
    };
};

const mapDispatchToProps = (dispatch) =>
{
    return {
        goToFilter: (tag) => {
            dispatch(setFilter(tag));
            browserHistory.push('/');
        }
    }
};

PlaceInfoContainer = connect(mapStateToProps, mapDispatchToProps)(PlaceInfoContainer);

export default PlaceInfoContainer;



// WEBPACK FOOTER //
// ./src/components/Place/containers/PlaceInfoContainer.js